module.exports = __webpack_public_path__ + "static/q17-8f90bafe9ca3d6c74d0598a96aede41d.png";